import { graphql } from "gql.tada";

/**
 * Seeds a tournament step. Accepts the caller-curated seeding order and
 * optional manual pins; the preset rule set drives actual team-to-game
 * assignment via SEEDING rules. Prior placements are discarded (idempotent
 * re-seed).
 */
export const SEED_TOURNAMENT_STEP_MUTATION = graphql(`
  mutation SeedTournamentStep($input: SeedStepInput!) {
    seedTournamentStep(input: $input) {
      id
      status
      seedingOrder
    }
  }
`);

/**
 * Persist a new seeding order on the step without re-seeding.
 * Order must be a permutation of the step teams.
 */
export const UPDATE_SEEDING_ORDER_MUTATION = graphql(`
  mutation UpdateSeedingOrder($stepId: ID!, $orderedTeamIds: [ID!]!) {
    updateSeedingOrder(stepId: $stepId, orderedTeamIds: $orderedTeamIds) {
      id
      seedingOrder
    }
  }
`);

/**
 * Persist a new manual-pin list on the step without re-seeding.
 * Pins anchor teams to a group, a game, or a specific slot within a game.
 */
export const UPDATE_SEEDING_PINS_MUTATION = graphql(`
  mutation UpdateSeedingPins($stepId: ID!, $pins: [SeedingPinInput!]!) {
    updateSeedingPins(stepId: $stepId, pins: $pins) {
      id
    }
  }
`);

/**
 * Withdraw a team from a step. Flips the team status to WITHDRAWN, fires the
 * TEAM_WITHDREW rule-engine event, and cascades bye resolution. Idempotent.
 */
export const WITHDRAW_TEAM_FROM_STEP_MUTATION = graphql(`
  mutation WithdrawTeamFromStep($stepId: ID!, $teamId: ID!) {
    withdrawTeamFromStep(stepId: $stepId, teamId: $teamId) {
      id
      status
    }
  }
`);

/**
 * Re-run the seeding pipeline from the step's currently persisted
 * seedingOrder + manualPins. The step must be in SEEDED status.
 */
export const RESEED_STEP_MUTATION = graphql(`
  mutation ReseedStep($stepId: ID!) {
    reseedStep(stepId: $stepId) {
      id
      status
    }
  }
`);
